module.exports = __webpack_public_path__ + "img/bed-bunk.d676f718.svg";